import {GET_ACTIVE_SUB_CATEGORIES, ACTIVE_SUB_CATEGORIES_ERROR} from '../types'

const initialState = {
    activeSubCategory:0,
    loading:true
}

export default function(state = initialState, action){

    switch(action.type){

        case GET_ACTIVE_SUB_CATEGORIES:
        

        return {
            ...state,
            activeSubCategory:action.payload,
            loading:false

        }
        case ACTIVE_SUB_CATEGORIES_ERROR:
            return{
                loading: false, 
                error: action.payload 
            }
        default: return state
    }

}